import { DirSport, useTypeSportsListSelectQuery } from '../api';
import React, { FC } from 'react';

import { ReactHookFormSelect } from '../components/Inputs/Select';
import { Select } from '../components/Inputs';

interface TypeSports
  extends Pick<ReactHookFormSelect, 'control' | 'name' | 'rules' | 'disabled' | 'label' | 'error' | 'errorMessage'> {
  data?: {
    value: DirSport['id'];
    label: DirSport['fullName'];
  }[];
  usedValue?: DirSport['id'][];
  multiple?: boolean;
}

const TypeSports: FC<TypeSports> = ({ disabled, usedValue, label, error, control, name, rules, data, multiple }) => {
  const { data: dirSports, loading } = useTypeSportsListSelectQuery();
  return (
    <Select
      label={label}
      data={
        data ||
        (usedValue && dirSports?.dirSports?.filter((sport) => usedValue?.indexOf(sport.value) === -1)) ||
        dirSports?.dirSports ||
        []
      }
      loading={loading}
      control={control}
      error={error}
      disabled={disabled}
      name={name}
      multiple={multiple}
      rules={rules}
    />
  );
};

export default TypeSports;
